import { List } from '@farol-ds/react'
import { COMPONENT_NAME } from '@jusbrasil-web/shared-ga4-events'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useEffect } from 'react'

import errorImgSrc from '../../../assets/id-document-validation/incompatibility.svg'
import { COMPONENT_RENDER_EVENT_PROPS, GA4EventHandlers } from '../../../hooks'
import { useStudentEnrollmentValidationContext } from '../context'
import { Steps } from '../enums'
import { EnrollmentStaticStep } from './enrollment-static-step'
import styles from './steps.module.scss'

interface EnrollmentErrorProps {
  gA4EventHandlers?: GA4EventHandlers
}

export function EnrollmentError(props: EnrollmentErrorProps) {
  const { gA4EventHandlers } = props
  const { sharedData, setCurrentStep, eventData, viewer } = useStudentEnrollmentValidationContext()
  const pid = viewer?.pid

  useEffect(() => {
    gA4EventHandlers?.sendComponentRender({
      componentClass: null,
      componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
      renders: COMPONENT_RENDER_EVENT_PROPS.STUDENT_ENROLLMENT_ERROR,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRetry = () => {
    sendMetrics('UserAccount.StudentEnrollmentProofFailedRetryClicked', `${pid}`, {
      ...eventData,
      metadata: { ...eventData?.metadata, rejectionReason: sharedData.rejectionReason },
    })
    setCurrentStep(Steps.ACADEMIC_DATA)
  }

  return (
    <EnrollmentStaticStep
      testId="enrollment-error-step"
      imageSrc={errorImgSrc}
      title="Não foi possível confirmar sua matrícula"
      bodyText="Tire uma nova foto do seu comprovante, em um lugar iluminado, garantindo que é possível ler:"
      bodyText2={
        <List unstyled={false} className={styles.reasonsList}>
          <List.Item>Nome completo igual ao seu documento</List.Item>
          <List.Item>O nome do seu curso</List.Item>
          <List.Item>Nome ou logo da faculdade</List.Item>
        </List>
      }
      action={{
        label: 'Tentar novamente',
        onClick: handleRetry,
      }}
      onLoadEvent={{
        name: 'UserAccount.StudentEnrollmentProofFailedViewed',
        metadata: {
          ...eventData?.metadata,
          rejectionReason: sharedData.rejectionReason,
          pid,
        },
      }}
    />
  )
}
